<template>
  <div class="cd_container py-5">
    <div class="cd_content">
      <h1 class="py-3">Reporting Guide</h1>
      <div class="cd_content--block pt-4 pb-3">
        <h2>Why report?</h2>
        <p>With your CreekDog pollution report, proper agencies are notified enabling them to quickly locate problems by knowing the exact location of the issue within the watershed.</p>
        <p>By monitoring fish population with CreekDog and by macro-invertabrate sampling, Friends of Deckers Creek gains insight on the health of the creek and recreation within the watershed. </p>
      </div>
      <div class="cd_content--block pt-4 pb-3">
        <h2>What should I report?</h2>
        <p>If you encounter any of the following types of pollution in the Deckers Creek watershed, report the issue with CreekDog:
          <ul>
            <li><strong>Construction Stormwater Pollution:</strong><br />Sediment being washed onto roads or streams or failing erosion control from construction sites.</li>
            <li><strong>Stream Dredge and Filling:</strong><br />The excavation or deposit of silt or vegetation within the watershed, often by heavy machinery. </li>
            <li><strong>Suspicious Oil and Gas Drilling Activity:</strong><br />Sediment or water being discharged into streams from well pads, water withdrawal that could cause a stream to flow extremely low, and truck spills. </li>
            <li><strong>Illegal Trash Sites:</strong><br /> Large and small dumped or littered items from appliances to cigarette butts.</li>
            <li><strong>Untreated Sewage:</strong><br /> Discharge from or failure of home septic tanks, agricultural runoff or sanitary sewer overflow. </li>
          </ul>
        </p>
        <p>CreekDog welcomes reports of all fish catches within the Deckers Creek watershed. </p>
      </div>

      <div class="cd_content--block pt-4 pb-3">
        <h2>When and where should I report? </h2>
        <p>Report <router-link :to="{ name: 'reportPollution' }">pollution</router-link> when you've encountered an issue while hiking, biking or fishing any time you are within 50 feet of a stream or tributary. CreekDog immediately alerts proper agencies of issues throughout the Deckers Creek watershed.  Report your <router-link :to="{ name: 'reportFish' }">fish catch</router-link> when you are on location.  </p>
        <p>If you do not have internet connection at the location of the issue or catch, take a photo and make your report as soon as you regain connectivity.</p>
      </div>
      <div class="cd_content--block pt-4 pb-3">
        <h2>Who gets notified? </h2>
        <p>Your CreekDog pollution report will notify one or more of the following agencies:
          <ul>
            <li>West Virginia Department of Environmental Protection (WVDEP)</li>
            <li>WVDEP Monongalia County</li>
            <li>WVDEP Preston County</li>
            <li>Morgantown Utility Board</li>
            <li>Army Corps Pittsburgh District</li>
            <li>Environmental Protection Agency</li>
            <li>Monongalia County Solid Waste Authority</li>
            <li>Preston County Litter Control Officer</li>
          </ul>
        </p>
        <p>Your CreekDog fish report will be used by Friends of Deckers Creek to help track healthy fish populations throughout the watershed. </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Guide'
  }
</script>
